import produce from "immer";
import {
  Table,
  TableColumn,
  TableColumns,
  TableRow,
} from "src/requests/table/types";
import { isColumnForbiddenType } from "./utils";

const filterColumns = (
  entry: [string, TableColumn],
  visibleColumnIds: string[]
): boolean => {
  const [colKey, column] = entry;
  if (isColumnForbiddenType(column)) return false;

  return visibleColumnIds.includes(colKey);
};

const removeCellsFromRow = (row: TableRow, columnKeys: string[]): TableRow => {
  const newCells = produce(row.cells, (draft) => {
    Object.keys(draft).forEach((colKey) => {
      if (!columnKeys.includes(colKey)) {
        delete draft[colKey];
      }
    });
  });

  return {
    ...row,
    cells: newCells,
  };
};

const getFilteredColumns = (
  columns: TableColumns,
  visibleColumnIds: string[]
): TableColumns => {
  const entries = Object.entries(columns).filter((entry) =>
    filterColumns(entry, visibleColumnIds)
  );
  return Object.fromEntries(entries);
};

const getFilteredRows = (
  rows: TableRow[],
  columns: TableColumns
): TableRow[] => {
  const columnsKeys = Object.keys(columns);
  const updatedRows = rows.map((row) => removeCellsFromRow(row, columnsKeys));
  return updatedRows;
};

const getTableDataWithVisibleColumns = (
  tableData: Table,
  visibleColumnIds: string[]
): Table => {
  const { columns, rows } = tableData;
  const filteredColumns = getFilteredColumns(columns, visibleColumnIds);
  const filteredRows = getFilteredRows(rows, filteredColumns);

  return {
    ...tableData,
    rows: filteredRows,
    columns: filteredColumns,
  };
};

export default getTableDataWithVisibleColumns;
